import { http } from '../index';

export const getCompanyJobRoleVersions = (jobRoleId, params) =>
  http
    .get(`/company-job-roles/${jobRoleId}/versions/list`, { params })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const createCompanyJobRoleVersion = (jobRoleId, formData) =>
  http
    .post(`/company-job-roles/${jobRoleId}/versions`, {
      ...formData,
      jobTaskId: Number(jobRoleId),
    })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const updateCompanyJobRoleVersion = (jobRoleId, versionId, formData) =>
  http
    .put(`/company-job-roles/${jobRoleId}/versions/${versionId}`, formData)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const launchCompanyJobRoleVersion = (jobRoleId, versionId) =>
  http
    .post(`/company-job-roles/${jobRoleId}/versions/${versionId}/launch`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const cancelCompanyJobRoleVersion = (jobRoleId, versionId) =>
  http
    .post(`/company-job-roles/${jobRoleId}/versions/${versionId}/cancel`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteCompanyJobRoleVersion = (jobRoleId, versionId) =>
  http
    .delete(`/company-job-roles/${jobRoleId}/versions/${versionId}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const getCompanyJobRoleVersionRequirements = (jobRoleId, versionId) =>
  http
    .get(`/company-job-roles/${jobRoleId}/versions/${versionId}/requirements`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const replaceCompanyJobRoleVersionRequirements = (jobRoleId, versionId, data) =>
  http
    .put(`/company-job-roles/${jobRoleId}/versions/${versionId}/requirements`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const previewCompanyJobRoleSync = companyJobRoleId =>
  http
    .get(`/company-job-roles/${companyJobRoleId}/sync-preview`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const applyCompanyJobRoleSync = (companyJobRoleId, data = {}) =>
  http
    .post(`/company-job-roles/${companyJobRoleId}/sync`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const rejectCompanyJobRoleSync = (companyJobRoleId, data = {}) =>
  http
    .post(`/company-job-roles/${companyJobRoleId}/sync-reject`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const previewCompanyTrainingModuleSync = companyTrainingModuleId =>
  http
    .get(`/company-training-modules/${companyTrainingModuleId}/sync-preview`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const applyCompanyTrainingModuleSync = (companyTrainingModuleId, data = {}) =>
  http
    .post(`/company-training-modules/${companyTrainingModuleId}/sync`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const rejectCompanyTrainingModuleSync = (companyTrainingModuleId, data = {}) =>
  http
    .post(`/company-training-modules/${companyTrainingModuleId}/sync-reject`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || error);
